import { ChangeDetectorRef, Component, DestroyRef, inject, Input, input, OnInit, output, signal } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { WorkRequestBottomSheetComponent } from "../work-request-bottom-sheet/work-request-bottom-sheet.component";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { Document } from "../../models/document.model";
import { first } from "rxjs";
import { FirebaseService } from "../../services/firebase.service";
import { MatButtonModule } from "@angular/material/button";
import { AdminService } from "../../admin/services/admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: 'app-work-request-button',
    template: `
      <button mat-raised-button (click)="addWork()" class="primary circle-button">
        <mat-icon>add</mat-icon>
      </button>
    `,
    styleUrls: ['./work-request-button.component.scss'],
    imports: [
      MatButtonModule,
      MatIconModule,
      MatProgressSpinnerModule,
    ],
})
export class WorkRequestButtonComponent implements OnInit {
  allowedDocumentsForCreation = input<string[]>();

  customActions = input<any[]>();

  disabled = input(false);

  document = input<Partial<Document>>();

  id = input.required<number>();

  status_id = input.required<number>();
  
  type = input.required<string>();

  
  afterDialogClose = output();


  private readonly adminService = inject(AdminService);

  private readonly bottomSheet = inject(MatBottomSheet);

  private readonly cdr = inject(ChangeDetectorRef);

  private readonly destroyRef = inject(DestroyRef);

  private readonly firebaseService = inject(FirebaseService);

  private readonly snackBar = inject(MatSnackBar);


  get workType() {
    return 'Work::' + this.type();
  }

  ngOnInit(): void {
    this.firebaseService.subscribeToMessages(
      'added-to-document',
      null,
      this.handleAddedToDocumentMessage.bind(this),
      this.destroyRef,
    );
  }

  addWork() {
    this.bottomSheet.open(WorkRequestBottomSheetComponent, {
      data: {
        document: this.document(),
        document_id: this.id(),
        document_type: this.type(),
        status_id: this.status_id(),
        work_type: this.workType,
        customActions: this.customActions(),
        allowedDocumentsForCreation: this.allowedDocumentsForCreation(),
      },
      panelClass: 'work-request-bottom-sheet',
    }).afterDismissed().pipe(first()).subscribe((value) => {
      if (value) {
        if (value === 'async') {
          this.cdr.detectChanges();
        }

        this.afterDialogClose.emit();
      }
    });
  }

  private handleAddedToDocumentMessage(data) {
    const documentName = this.adminService.getText(data.type || data.document_type) || 'documento';
    this.snackBar.open(
      `Has sido agregado(a) al(a) ${documentName}`,
      'Cerrar',
      { duration: 5000 },
    );
  }
}
